// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__2m0i3","right-arrow":"classes_right-arrow__1BSf_","left-up-arrow":"classes_left-up-arrow__1_knR"};